import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import Report from 'src/constants/report';

export enum WarningTopBannerType {
    InvitationsStatistics = 'invitationsStatistics',
}

export default autoGeneratedReducer<Record<Report, WarningTopBannerType>>(null);
